import script from "./Bid.vue?vue&type=script&setup=true&lang=ts"
export * from "./Bid.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__